import table from "./slot-actions.json";
import type { SlotStatus } from "./dossier";

/** What a CLIENT may do to a checklist item, per slot status (spec 019).
 *
 * ONE table, read by three parties so they cannot drift apart: the web UI
 * (which buttons it offers), the web mock backend (what it accepts), and
 * document-svc's `tests/test_slot_actions_contract.py` (what the real gate and
 * discard guard accept). The in-review "Upload replacement" shipped broken
 * precisely because the UI and the server each held their own copy.
 *
 * `client_remove` applies only when the slot holds a document, and per
 * DOCUMENT: a document filling any slot whose status forbids removal cannot be
 * removed from any row. Dossier-level rules (cancelled/expired, a required item
 * of a COMPLETE dossier, signed-link mode) apply on top. */
export interface SlotClientActions {
  client_upload: boolean;
  client_remove: boolean;
}

export const SLOT_ACTIONS: Readonly<Record<SlotStatus, SlotClientActions>> =
  table;

/** Unknown statuses offer nothing — never guess permissive. */
export function slotActions(status: string): SlotClientActions {
  return (
    (SLOT_ACTIONS as Record<string, SlotClientActions | undefined>)[status] ?? {
      client_upload: false,
      client_remove: false,
    }
  );
}
